import React from "react";

const SystemPageContent = ({ children }) => (
  <div className="system-page-content">{children}</div>
);

export default SystemPageContent;
